module.exports = __webpack_public_path__ + "img/price-click-2.9fdbd68d.webp";